import { render, staticRenderFns } from "./UserViewSidebarAdd.vue?vue&type=template&id=03711380&scoped=true&"
import script from "./UserViewSidebarAdd.vue?vue&type=script&lang=js&"
export * from "./UserViewSidebarAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserViewSidebarAdd.vue?vue&type=style&index=0&id=03711380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03711380",
  null
  
)

export default component.exports